import React, { PropTypes, PureComponent } from 'react';
import Google from '../../../../lib/google';
import styles from './styles.scss';

export class Places extends PureComponent {
  constructor(props) {
    super(props);
    this.link = this.link.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onValChange = this.onValChange.bind(this);

    const { error } = props;
    const showError = false;
    const valid = false;
    const linked = false;
    const autocomplete = null;
    this.state = {
      linked, autocomplete, showError, valid, error,
    };
  }


  onValChange(onChange, onValidation) {
    const { autocomplete } = this.state;
    const place = autocomplete.getPlace();

    let address;
    if (place) {
      address = { address: place.formatted_address };

      if (place.geometry) {
        address = {
          address: place.formatted_address,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        };
      }

      this.setState({ valid: true });
      if (onValidation) {
        onValidation(true);
      }
    } else if (onValidation) {
      this.setState({ valid: false });
      onValidation(false);
    }

    this.props.onChange(address);
  }


  /**
   * sets showError if it should be...
   * @param  {Boolean} showError is used to determine whether errors are to be shown
   * @param  {String} value to be checked if exists
   */
  onBlur(showError, value) {
    if (!showError && value) {
      this.setState({ showError: true });
    }
  }

  link(onValChange, onChange, onValidation) {
    if (!this.state.linked && Google.maps) {
      const el = document.getElementById(this.props.id);
      const autocomplete = new Google.maps.places.Autocomplete(el);
      autocomplete.addListener(
        'place_changed',
        () => onValChange(onChange, onValidation),
      );

      this.setState({ linked: true, autocomplete });
    }
  }


  render() {
    const {
      props, state, link, onValChange, onBlur,
    } = this;
    const { showError, valid, error } = state;
    const {
      id,
      className,
      name,
      onChange,
      onValidation,
      placeholder,
      value,
    } = props;

    let borderError;
    if (showError && !valid && error) {
      borderError = styles.errorBorder;
    }

    return (
      <div className={styles.view}>
        <input
          id={id}
          className={`${styles.input} ${className} ${borderError}`}
          name={name}
          onChange={() => link(onValChange, onChange, onValidation)}
          onBlur={() => onBlur(showError, value)}
          defaultValue={value.address}
          placeholder={placeholder}
        />
        <p className={styles.error}>{showError && !valid ? error : null}</p>
      </div>
    );
  }
}


Places.propTypes = {
  className: PropTypes.string,
};


export default Places;

/* eslint no-unused-vars: 0 */



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/places/index.jsx